<!-- Button -->
<button *transloco="let t" mat-icon-button (click)="changeScheme()" matTooltip="{{ t(scheme) }}">
    <mat-icon class="w-full">{{ getSchemeIcon() }}</mat-icon>
</button>
